import { useTranslation } from '@sailor/i18n-web'
import { BizOrderStatusEnum, PayTypeEnum } from '../types'

const useOrderMaps = () => {
  const { t } = useTranslation()
  const payTypeMap: Record<string, string> = {
    [PayTypeEnum.CorporatePay]: t('e_pc_payment_corporate', '企业支付'),
    [PayTypeEnum.PersonalPay]: t('e_pc_payment_personal', '个人支付'),
    [PayTypeEnum.CombinedPay]: t('e_pc_payment_combined', '组合支付'),
  }
  const statusMap: Record<number, string> = {
    [BizOrderStatusEnum.Submitted]: t('e_pc_order_submitted', '已提单'),
    [BizOrderStatusEnum.Paid]: t('e_pc_order_paid', '已支付'),
    [BizOrderStatusEnum.Confirmed]: t('e_pc_order_merchant_confirmed', '商家已确认'),
    [BizOrderStatusEnum.Completed]: t('e_pc_order_completed', '已完成'),
    [BizOrderStatusEnum.Cancelled]: t('e_pc_order_cancelled', '已取消'),
  }
  const userGetModeMap = {
    delivery: t('e_pc_delivery', '外卖'),
    pickup: t('e_pc_pickup', '自提'),
  }

  return {
    payTypeMap,
    statusMap,
    userGetModeMap,
  }
}
export default useOrderMaps